"use client";

import { useUserRealmId } from "@easybiz/component-shared";
import { collection, getFirestore, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";

export default () => {
  const realmId = useUserRealmId();
  const [options, setOptions] = useState(null);

  useEffect(() => {
    setOptions(null);
    if (realmId) {
      return onSnapshot(
        query(collection(getFirestore(), `realms/${realmId}/topup_options`), orderBy("amount")),
        (result) => setOptions(result.docs)
      );
    }
  }, [realmId]);

  return options;
};
